const PRECISION = 0.0002;

export function areMapCoordsEqual(n1: number, n2: number) {
  return Math.abs(n1 - n2) < PRECISION;
}
